import React, {useState} from 'react'
import { Maximize2, Minimize2 } from 'lucide-react';


const AnalysisCompanies = ({selectedCompanies, onDeleteClick, onDeleteAllClick}) => {
  const [showDeleteAllTooltip, setShowDeleteAllTooltip] = useState(false);
  const [openCompanies, setOpenCompanies] = useState(true);
  
  return (
    <div 
        className="analysis-company-container" 
        style={openCompanies ? {} : { minHeight: '20px', important: 'true' }}
        >
        <div className='flex relative'>
            <div>
                分析対象企業
            </div>
            <div 
                id="remove-all-companies-button" 
                onClick={onDeleteAllClick} 
                onMouseEnter={() => setShowDeleteAllTooltip(true)} 
                onMouseLeave={() => setShowDeleteAllTooltip(false)}>
                    <i className="fa-solid fa-eraser"></i>
            </div>
            {showDeleteAllTooltip && <span className='delete-all-tooltip'>すべて削除する</span>}
            <div className='absolute right-4 hover:bg-gray-300 p-1 rounded' onClick={() => setOpenCompanies(!openCompanies)}>{openCompanies ? <Minimize2 className='h-5 w-5'/>: <Maximize2 />}</div>
        </div>
        {openCompanies && (
            selectedCompanies.length === 0 ? (
                <div className='w-full rounded-lg bg-white p-3 mt-2 !text-gray-500'>
                    分析対象企業を左から選択してください
                </div>
            ) : (
                <div className="analysis-company-list">
                    {selectedCompanies.map((company) => (
                        <div key={company.secCode} className="bg-gray-200">
                            <span className="analyze-company-sec-code">{company.secCode}</span>
                            <span className="analyze-company-company-name">{company.companyName}</span>
                            <i
                                className="fa-solid fa-xmark delete-company-list"
                                onClick={() => onDeleteClick(company.secCode)}
                            ></i>
                        </div>
                    ))}
                </div>
            )
        )}

        
    </div>
  )
}

export default AnalysisCompanies